module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h2', [_vm._v("扫码核销")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "Sweep"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'Sweep.jpg'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.scan
    }
  }, [_vm._v("扫一扫核销")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v("\n      用户打开直播间的【个人中心】，进入【我的卡包】页面。点击【立即核销】按钮，核销管理员扫描核销二维码，确认核销信息，即可完成核销。\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a94c98e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exchange/scan.vue
// module id = 500
// module chunks = 0